import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { LayoutService } from 'codex-lib';
import { EnvelopeSource } from 'src/app/enum/envelope-source';
import { RoutePages } from 'src/app/enum/route-pages';
import { SentEnvelopeStatus } from 'src/app/enum/sent-envelope-status';
import { AuthService } from 'src/app/services/auth.service';
import { Envelope } from '../../model/envelope';
import { EnvelopeStructure } from '../../model/envelope-structure';
import { UserTypes } from 'src/app/enum/user-types';
import { SurvicateService } from 'src/app/services/survicate.service';
import { AnalyticEventClient } from 'src/app/enum/analytic-event-client.enum';
import { TrackerData } from 'src/app/modules/google-analytics/model/tracker-data.model';
import { AnalyticsService } from 'src/app/modules/google-analytics/service/analytics.service';


@Component({
  selector: 'app-sent-list',
  templateUrl: './sent-list.component.html',
  styleUrls: ['./sent-list.component.scss']
})
export class SentListComponent implements OnInit {

  @Output() showEnvelopeDetails = new EventEmitter();

  _envelopeStructure: EnvelopeStructure;
  profileType = null;
  source = EnvelopeSource;
  suiteUserName: string;
  userType = UserTypes;

  constructor(
    private survicateService: SurvicateService,
    private authService: AuthService,
    private router: Router,
    public layoutService: LayoutService,
    private googleAnalyticsService: AnalyticsService) {
  }

  get envelopeStructure(): EnvelopeStructure {
    return this._envelopeStructure;
  }

  @Input() set envelopeStructure(value: EnvelopeStructure) {
    this.processValue(value);
  }

  ngOnInit() { }

  getStyleByStatus(status: number) {
    switch (status) {
      case SentEnvelopeStatus.pending:
        return 'warning';
      case SentEnvelopeStatus.completed:
        return 'success';
      case SentEnvelopeStatus.expired:
        return 'warning';
      case SentEnvelopeStatus.onApproval:
        return 'info';
      case SentEnvelopeStatus.toFill:
        return 'info';
      case SentEnvelopeStatus.reproved:
        return 'danger';
      case SentEnvelopeStatus.deleted:
        return 'danger';
      case SentEnvelopeStatus.rejected:
        return 'danger';
      default:
        return '';
    }
  }

  onCardClick(idBtn, envelope) {
    // Detalhar
    if (idBtn === 0) {
      this.showEnvelopeDetails.emit(envelope.id);
    }
    if (idBtn === 1) { // Editar
      this.trackAnalyticsEvent('Signer_Enviado_Editar');
      this.layoutService.toggleRightAside(false);
      this.router.navigate([RoutePages.EditEnvelope, envelope.id]);
    }
  }

  processValue(value: EnvelopeStructure): void {
    if (!value || !Array.isArray(value.list)) {
      this._envelopeStructure = Object.assign({}, value);
      return;
    }

    this.authService.authModel.subscribe(user => {
      if (!user) {
        return;
      }
      this.profileType = user.signUser.type;
      this.suiteUserName = user.signUser.name;
    });

    value.list.map(envelope => {
      if (envelope) {
        const normalizedStatus = Number((envelope as any).status);
        if (Number.isFinite(normalizedStatus)) {
          envelope.status = normalizedStatus as SentEnvelopeStatus;
        }

        if (!Array.isArray(envelope.files)) {
          envelope.files = [];
        }
      }

      const buttons = [
        {
          span: 'envelope.sent.card.buttonOne',
          icon: {
            prefix: 'fas',
            iconName: 'info-circle',
          }
        }
      ];

      if (this.userCanEnvelopeEdit(envelope)) {
        buttons.push({
          span: 'envelope.sent.card.buttonTwo',
          icon: {
            prefix: 'fal',
            iconName: 'pencil',
          },
        });
      }

      envelope.cardOptions = Object.assign({}, {
        isList: value.isList,
        status: this.getStyleByStatus(envelope.status),
        doubleClick: true,
        button: buttons
      });
    });

    this._envelopeStructure = Object.assign({}, value);
  }

  userCanEnvelopeEdit(envelope: Envelope) {
    if (!envelope) {
      return false;
    }


    if (envelope.status === SentEnvelopeStatus.toFill && this.profileType !== this.userType.User) {
      return true;
    }

    const files = Array.isArray(envelope.files) ? envelope.files : [];
    const allFilesRejected = files.length > 0
      && files.every(file => file.envelopeRejectedHistory && file.envelopeRejectedHistory.length > 0);
    const allSignatoriesRejected = envelope.totalSignatures === envelope.totalRejected;

    if (allFilesRejected && allSignatoriesRejected) {
      return false;
    }

    if (this.survicateService.isSignFree() && (envelope.status !== SentEnvelopeStatus.completed
      && envelope.status !== SentEnvelopeStatus.deleted && envelope.status !== SentEnvelopeStatus.reproved)) {
      return true;
    }

    if ((envelope.source === this.source.EXTERNAL && this.profileType === this.userType.Admin)
      && (envelope.status !== SentEnvelopeStatus.completed && envelope.status !== SentEnvelopeStatus.deleted)) {
      return true;
    }

    if (((envelope.suiteUserName === this.suiteUserName && this.profileType !== this.userType.User)
      || this.profileType === this.userType.Admin) && (envelope.status !== SentEnvelopeStatus.completed
        && envelope.status !== SentEnvelopeStatus.deleted && envelope.status !== SentEnvelopeStatus.reproved)) {
      return true;
    }

    return false;
  }

  private trackAnalyticsEvent(action: string): void {
    this.googleAnalyticsService.sendEvent(
      new TrackerData(AnalyticEventClient.TK_PT_SIGNER_SENT, action)
    );
  }

}
